import { render, staticRenderFns } from "./useDetail.vue?vue&type=template&id=069ae7bc&scoped=true"
import script from "./useDetail.vue?vue&type=script&lang=js"
export * from "./useDetail.vue?vue&type=script&lang=js"
import style0 from "./useDetail.vue?vue&type=style&index=0&id=069ae7bc&lang=scss"
import style1 from "./useDetail.vue?vue&type=style&index=1&id=069ae7bc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ae7bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069ae7bc')) {
      api.createRecord('069ae7bc', component.options)
    } else {
      api.reload('069ae7bc', component.options)
    }
    module.hot.accept("./useDetail.vue?vue&type=template&id=069ae7bc&scoped=true", function () {
      api.rerender('069ae7bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketingManage/couponManage/useDetail.vue"
export default component.exports